<template>
  <div class="sheet_wrap">
    <div class="image">
      <div>
        <div class="label"
             style="margin-left:0px">答题卡正面</div>
        <div v-if="form.excel_image_one"
             class="pub"
             :style="{
            width:fixed_1_width + 'px',
            height:fixed_1_height + 'px',
            background:`url(${form.excel_image_one+'?random='+Math.random()}}
)`,
            'background-size':`${fixed_1_width}px ${fixed_1_height}px`
          }">
        </div>
        <div v-else
             class="add_img"
             :style="{
            width:fixed_1_width + 'px',
            height:fixed_1_height + 'px'}">
          <div class="wrap">
            <div>
              <img src="@/assets/addimg.png"
                   alt="">
            </div>
            请上传答题卡正面
          </div>
        </div>
      </div>
      <div>
        <div class="label">预览 <div v-if="form.excel_image_one&&signAbled"
               @click="showSign(1)">标注</div>
        </div>
        <div class="priview"
             :style="{
              width:fixed_1_width + 'px',
            height:fixed_1_height + 'px',
            background:`url(${form.excel_image_one+'?random='+Math.random()})`,
            'background-size':`${fixed_1_width}px ${fixed_1_height}px`
        }">
          <div class="sign"
               v-for="(item,index) in JSON.parse(form.mark_image_one_json)"
               :key="index"
               v-show="item.points.w"
               :style="{
          top:item.points.y / ratioH+'px',
        left:item.points.x / ratioW+'px',
        width:item.points.w / ratioW+'px',
        height:item.points.h / ratioH+'px',
        background:item.color
        }">
            {{item.label}}
          </div>
        </div>
      </div>
    </div>
    <div class="image">
      <div>
        <div class="label"
             style="margin-left:0px">答题卡反面</div>
        <div v-if="form.excel_image_two"
             class="pub"
             :style="{
            width:fixed_1_width + 'px',
            height:fixed_1_height + 'px',
            background:`url(${form.excel_image_two}?random=${Math.random()})`,
            'background-size':`${fixed_1_width}px ${fixed_1_height}px`
          }">
        </div>
        <div v-else
             class="add_img"
             :style="{
            width:fixed_1_width + 'px',
            height:fixed_1_height + 'px'}">
          <div class="wrap">
            <div>
              <img src="@/assets/addimg.png"
                   alt="">
            </div>
            请上传答题卡反面
          </div>
        </div>
      </div>
      <div>
        <div class="label">预览 <div v-if="form.excel_image_two&&signAbled"
               @click="showSign(2)">标注</div>
        </div>
        <div class="priview"
             :style="{ 
            width:fixed_1_width + 'px',
            height:fixed_1_height + 'px',
            background:`url(${form.excel_image_two +'?random='+Math.random()})`,
            'background-size':`${fixed_1_width}px ${fixed_1_height}px`
          }">
          <div class="sign"
               v-for="(item,index) in JSON.parse(form.mark_image_two_json)"
               :key="index"
               v-show="item.points.w"
               :style="{
                top:item.points.y / ratioH+'px',
        left:item.points.x / ratioW+'px',
        width:item.points.w / ratioW+'px',
        height:item.points.h / ratioH+'px',
              background:item.color
        }">
            {{item.label}}
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_box"
         v-if="show">
      <Sign ref="signRef"
            @setData="setData"
            @cancelSign="cancelSign"
            :size="size" />
    </div>
    <img class="fixed_1"
         :src="form.excel_image_one+'?random='+Math.random()"
         alt="">
    <img class="fixed_2"
         :src="form.excel_image_two+'?random='+Math.random()"
         alt="">
  </div>
</template>

<script>
// import Sign from './index.vue'
import Sign from './Sign.vue'


export default {
  components: {
    Sign
  },
  data () {
    return {
      ratioH: 1,
      ratioW: 1,
      // 预览图的属性
      fixed_1_width: 560,
      fixed_1_height: 417,
      show: false,
    }


  },
  props: ['form', 'signAbled', 'size'],//  , 'size'


  methods: {
    cancelSign () {
      this.show = false
    },
    getFixedImage () {
      this.$forceUpdate()
      // setTimeout(() => {
      var img1 = document.getElementsByClassName('fixed_1')[0]
      // this.ratioW = img1.clientWidth / 560
      // this.ratioH = img1.clientHeight / 417
      let that = this
      img1.onload = () => {
        console.log(img1.clientWidth)
        if (img1.clientWidth < img1.clientHeight) {
          this.fixed_1_width = 417
          this.fixed_1_height = 560

        } else {
          this.fixed_1_width = 560
          this.fixed_1_height = 417
        }
        this.ratioW = img1.clientWidth / this.fixed_1_width
        this.ratioH = img1.clientHeight / this.fixed_1_height
        console.log(11)
      }

      // }, 1000);

    },
    showSign (num) {
      this.show = true
      this.$nextTick(() => {
        let url = ''
        if (num == 1) {
          url = this.form.excel_image_two + '?random=' + Math.random()
        } else {
          url = this.form.mark_image_two + '?random=' + Math.random()
        }
        let urlObj = {
          1: 'excel_image_one',
          2: 'excel_image_two'
        }
        let jsonObj = {
          1: 'mark_image_one_json',
          2: 'mark_image_two_json'
        }
        let json = JSON.parse(this.form[jsonObj[num]]).map(item => {
          item.points.y *= 0.3
          item.points.x *= 0.3
          item.points.w *= 0.3
          item.points.h *= 0.3

          return item
        })
        this.$refs.signRef.initData(json, this.form[urlObj[num]] + '?random=' + Math.random(), num)
        // this.$refs.signRef.size = this.size

      })
    },
    setData (num, url, json) {
      console.log("t", json)
      let jsonObj = {
        1: 'mark_image_one_json',
        2: 'mark_image_two_json'
      }
      this.form[jsonObj[num]] = json
      // console.log(this.form, "form")
      this.show = false
    },

  }

}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;
}

.image {
  display: flex;
  .label {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    height: 34px;
    color: #333333;
    margin: 20px 0;
    display: flex;
    align-items: center;
    margin-left: 50px;
    div {
      width: 90px;
      height: 32px;
      background: #ecf5ff;
      border-radius: 2px;
      border: 1px solid #3f9eff;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      font-weight: bold;
      color: #3f9eff;
      margin-left: 20px;
      cursor: pointer;
    }
  }
  div {
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
  }
  .btn {
    margin-left: 20px;
  }
}
.fixed_box {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 200000000;
  background: white;
  overflow: auto;
}
.pub {
  border-radius: 10px;
  border: 2px solid #d9d9d9;
}
.priview {
  position: relative;
  width: 560px;
  height: 417px;
  margin-left: 50px;
  border-radius: 10px;
  border: 2px solid #d9d9d9;
  div {
    position: absolute;
    background: red;
    opacity: 0.3;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.fixed_1 {
  position: fixed;
  right: 100000px;
}
.fixed_2 {
  position: fixed;
  right: 100000px;
}
::v-deep .el-message--warning {
  z-index: 2001 !important;
}
.add_img {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 10px;
  border: 2px solid #d9d9d9;
  // cursor: pointer;
  img {
    width: 80px;
    height: 72px;
    margin-bottom: 20px;
  }
}
.sheet_wrap {
  overflow: auto;
}
</style>